import { Injectable } from '@angular/core';

import { APIService } from './api.service';
import { HttpClient } from '@angular/common/http';
import {PlayerEventRating} from '@shared/models/player';

@Injectable({
    providedIn: 'root'
})
export class PlayerService {

  private playersRoute = 'players';

  constructor(
    private http: HttpClient,
    private apiService: APIService,
  ) {}

  /***************************** HTTP GET FUNCTIONS *****************************/

  fetchPlayerEventRating(seasonRoundInfoId: string, playerId: string): Promise<PlayerEventRating> {
    return this.http.get(this.getPlayerEventRatingRoute(seasonRoundInfoId, playerId), this.apiService.getJsonOptions())
      .toPromise()
      .then((response: any) => this.resolvePlayerEventRating(response.data))
      .catch(error => {
        return this.handleError(error);
      });
  }

  /***************************** RESOLVE FUNCTIONS *****************************/

  private resolvePlayerEventRating(jsonRating): PlayerEventRating {
    return jsonRating as PlayerEventRating;
  }


  /***************************** ROUTE DEFINITIONS *****************************/

  private getPlayerEventRatingRoute(seasonRoundInfoId: string, playerId: string): string {
    return this.apiService.getBaseURL() + `v2/${this.playersRoute}/eventrating/${seasonRoundInfoId}/${playerId}`;
  }


  private handleError(error) {
    console.log(error);
    return null;
  }
}
